"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { RxChevronRight } from "react-icons/rx";

export function SecuritySA() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 ">
      <div className="container  md:max-w-5xl lg:max-w-7xl mx-auto ">
        <div className="flex flex-col items-start">
          <div className="rb-12 mb-12 grid grid-cols-1 items-start justify-between gap-5 md:mb-18 md:grid-cols-2 md:gap-x-12 md:gap-y-8 lg:mb-20 lg:gap-x-20">
            <div>
              <p className="mb-3 font-semibold md:mb-4">Security</p>
              <h2 className="mb-5 text-4xl leading-[1.2] md:mb-6 md:text-[45px] lg:text-[45px] max-w-[500px] ">
              Was ist eine Sicherheitsbewertung?               </h2>
            </div>
            <div>
              <p className="md:text-[16px] max-w-[470px] ">
              Eine Sicherheitsbewertung ist ein systematischer Prozess zur Identifizierung und Analyse von Schwachstellen in Ihrer IT-Infrastruktur, um geeignete Sicherheitsmaßnahmen zu implementieren.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 items-start gap-y-12 md:grid-cols-3 md:gap-x-8 md:gap-y-16 lg:gap-x-12">
            <div>
              <div className="rb-5 mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  alt="Relume logo"
                  className="size-12"
                />
              </div>
              <h3 className="mb-5 text-xl md:mb-6 md:text-2xl md:leading-[1.3] lg:text-3xl">
              Datenerhebung              </h3>
              <p>Wir sammeln relevante Informationen über Ihre Systeme, Netzwerke und Anwendungen, um ein vollständiges Bild Ihrer aktuellen Sicherheitslage zu erhalten.</p>
            </div>
            <div>
              <div className="rb-5 mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  alt="Relume logo"
                  className="size-12"
                />
              </div>
              <h3 className="mb-5 text-xl md:mb-6 md:text-2xl md:leading-[1.3] lg:text-3xl">
              Analyse
              </h3>
              <p>Anhand der gesammelten Daten bewerten wir potenzielle Bedrohungen und Schwachstellen, die Ihr Unternehmen gefährden könnten.</p>
            </div>
            <div>
              <div className="rb-5 mb-5 md:mb-6">
                <img
                  src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                  alt="Relume logo"
                  className="size-12"
                />
              </div>
              <h3 className="mb-5 text-xl md:mb-6 md:text-2xl md:leading-[1.3] lg:text-3xl">
              Berichterstellung
              </h3>
              <p>Sie erhalten einen detaillierten Bericht mit unseren Erkenntnissen, einer Bewertung der Risiken und konkreten Empfehlungen zur Verbesserung Ihrer Sicherheitsmaßnahmen.</p>
            </div>
          </div>
          <div className="mt-10 flex items-center gap-4 md:mt-14 lg:mt-16">
         
          </div>
        </div>
      </div>
    </section>
  );
}
